import { SelfAssessment } from './self-assessment';
export class VersionFilterViewModel {
    selfAssessment: SelfAssessment;
    versionId: number;
    filterType: string;
    templateId: number;

    constructor() {
        this.selfAssessment = new SelfAssessment();
        this.versionId = 0;
        this.filterType = '';
        this.templateId = 0;
    }
}